import classnames from 'classnames';

import { APIShowcaseCodeBlock } from '@/types';
import { useShowcaseDispatch, useShowcaseState } from './context';

type ShowcaseNavProps = {
  items: APIShowcaseCodeBlock[];
  horizontalLayout?: boolean;
};

export default function ShowcaseNav({
  horizontalLayout,
  items = [],
}: ShowcaseNavProps) {
  const dispatch = useShowcaseDispatch();
  const { activeSection } = useShowcaseState();

  if (!items || items.length === 0) return null;

  return (
    <div
      className={classnames({
        'py-3 md:items-center md:justify-around lg:flex': horizontalLayout,
        'px-4 md:w-2/5': !horizontalLayout,
      })}
    >
      <div
        className={classnames(`mt-6 text-center`, {
          'rounded bg-white px-3 shadow': horizontalLayout,
          'flex flex-col': !horizontalLayout,
        })}
      >
        {items.map((item, index) => {
          const isActive = item === activeSection;
          const showDescription =
            !horizontalLayout && isActive && item.description;

          return (
            <button
              type="button"
              key={index}
              className={classnames(
                `focus:outline-none my-2 inline-block cursor-pointer font-bold hover:text-rose focus:text-rose`,
                {
                  'text-rose': isActive,
                  'py-2 px-3 text-center text-sm text-cornflower':
                    horizontalLayout,
                  'flex flex-col rounded py-3 px-4 text-left text-base text-mid-gray':
                    !horizontalLayout,
                  'bg-white shadow-sm': isActive && !horizontalLayout,
                },
              )}
              onClick={() => dispatch({ type: `SET_ACTIVE`, section: item })}
            >
              <div
                className={classnames(`flex items-center`, {
                  'text-lg': !horizontalLayout,
                })}
              >
                {item.title}
              </div>
              {showDescription && (
                <span className="mt-2 font-medium text-haiti">
                  {item.description}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
